import script from "./Partner.vue?vue&type=script&setup=true&lang=js"
export * from "./Partner.vue?vue&type=script&setup=true&lang=js"

import "./Partner.vue?vue&type=style&index=0&id=184093df&lang=css"

const __exports__ = script;

export default __exports__